import { render, staticRenderFns } from "./BtnStock.vue?vue&type=template&id=3e00c85c&scoped=true&"
import script from "./BtnStock.vue?vue&type=script&lang=js&"
export * from "./BtnStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e00c85c",
  null
  
)

export default component.exports